export default "//yastatic.net/s3/distribution/pythia/frontend/_/3c14e716199c5f5e23bd554ed0972a9f.png";